export default "__VITE_ASSET__DvBY7fKC__"